import { Pressable, View } from 'react-native'
import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      position: 'relative',
      zIndex: theme.zindexOverlay,
    },
  }
})

export const ModalOverlay = styled(Pressable, theme => {
  return {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'transparent',
      zIndex: theme.zindexAbove,
    },
  }
})
